import _possibleConstructorReturn from "/Users/jameslin/Projects/agt-all-stars/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jameslin/Projects/agt-all-stars/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jameslin/Projects/agt-all-stars/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _classCallCheck from "/Users/jameslin/Projects/agt-all-stars/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/jameslin/Projects/agt-all-stars/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var BaseCache = /*#__PURE__*/function () {
  function BaseCache() {
    _classCallCheck(this, BaseCache);

    this.cache = {};
  }

  _createClass(BaseCache, [{
    key: "get",
    value: function get(key) {
      return this.cache[key];
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this.cache[key] = value;
    }
  }, {
    key: "flushAll",
    value: function flushAll() {
      this.cache = {};
    }
  }]);

  return BaseCache;
}();

var DefaultCache = /*#__PURE__*/function (_BaseCache) {
  _inherits(DefaultCache, _BaseCache);

  function DefaultCache() {
    _classCallCheck(this, DefaultCache);

    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultCache).apply(this, arguments));
  }

  return DefaultCache;
}(BaseCache);

var Cache = /*#__PURE__*/function () {
  function Cache(cache) {
    _classCallCheck(this, Cache);

    this.cache = cache;
  }

  _createClass(Cache, null, [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.instance) {
        this.instance = new Cache(new DefaultCache());
      }

      return this.instance;
    }
  }, {
    key: "get",
    value: function get(uuid) {
      return this.getInstance().cache.get(uuid);
    }
  }, {
    key: "set",
    value: function set(uuid, etag, value) {
      return this.getInstance().cache.set(uuid, {
        etag: etag,
        value: value
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.getInstance().cache.flushAll();
    }
  }]);

  return Cache;
}();

var byLowerCase = function byLowerCase(toFind) {
  return function (value) {
    return toLowerCase(value) === toFind;
  };
};

var toLowerCase = function toLowerCase(value) {
  return value.toLowerCase();
};

var getKeys = function getKeys(headers) {
  return Object.keys(headers);
};

var getHeaderCaseInsensitive = function getHeaderCaseInsensitive(headerName) {
  var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var key = getKeys(headers).find(byLowerCase(headerName));
  return key ? headers[key] : undefined;
};

function isCacheableMethod(config) {
  if (!config.method) {
    return false;
  }

  return ~['GET', 'HEAD'].indexOf(config.method.toUpperCase());
}

function getUrlByAxiosConfig(config) {
  return config.url;
}

var getCacheByAxiosConfig = function getCacheByAxiosConfig(config) {
  var url = getUrlByAxiosConfig(config);

  if (url) {
    return Cache.get(url);
  }

  return undefined;
};

function requestInterceptor(config) {
  if (isCacheableMethod(config)) {
    var url = getUrlByAxiosConfig(config);

    if (!url) {
      return undefined;
    }

    var lastCachedResult = Cache.get(url);

    if (lastCachedResult) {
      config.headers = Object.assign(Object.assign({}, config.headers), {
        'If-None-Match': lastCachedResult.etag
      });
    }
  }

  return config;
}

function responseInterceptor(response) {
  if (isCacheableMethod(response.config)) {
    var responseETAG = getHeaderCaseInsensitive('etag', response.headers);

    if (responseETAG) {
      var url = getUrlByAxiosConfig(response.config);

      if (!url) {
        return null;
      }

      Cache.set(url, responseETAG, response.data);
    }
  }

  return response;
}

function responseErrorInterceptor(error) {
  if (error.response && error.response.status === 304) {
    var getCachedResult = getCacheByAxiosConfig(error.response.config);

    if (!getCachedResult) {
      return Promise.reject(error);
    }

    var newResponse = error.response;
    newResponse.status = 200;
    newResponse.data = getCachedResult.value;
    return Promise.resolve(newResponse);
  }

  return Promise.reject(error);
}

function resetCache() {
  Cache.reset();
}

function axiosETAGCache(axiosInstance) {
  axiosInstance.interceptors.request.use(requestInterceptor);
  axiosInstance.interceptors.response.use(responseInterceptor, responseErrorInterceptor);
  return axiosInstance;
}

export { BaseCache, Cache, DefaultCache, axiosETAGCache, getCacheByAxiosConfig, resetCache };